<app-page-panel
  [showBackButton]="false"
  iconNameFontAwesome="wallet"
  pageTitle="Archiv"
  [showDetailsButton]="false"
  [showSidepanelButton]="false"
  [showBackColor]="true">
  <dx-data-grid #dataGridArchiv fxFill
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="true"
    [allowColumnReordering]="true"
    [hoverStateEnabled]="true"
    noDataText=""
    [dataSource]="budgetantraege()"
    (onRowDblClick)="onDataGridRowDblClick($event)"
    (onContentReady)="onContentReady($event)"
    (onInitialized)="onGridInitialized($event)"
    (onExporting)="onGridExporting($event)"
    [height]="'calc(100vh - 146px)'">
	 <dxo-export [enabled]="true"></dxo-export>
    <dxi-column dataField="budgetantragID" caption="BaID" [width]="80" [visible]="false" alignment="left"></dxi-column>
    <dxi-column dataField="projektID" caption="ProjektID" [width]="80" [visible]="false" alignment="left"></dxi-column>
    <dxi-column dataField="wipBezeichnung" caption="WIP" alignment="left" minWidth="80"></dxi-column>
    <dxi-column dataField="projektName" caption="Projekt" alignment="left" minWidth="200"></dxi-column>
    <dxi-column dataField="controllingbereich" caption="Controllingbereich" minWidth="120" [visible]="true" alignment="left"></dxi-column>
    <dxi-column dataField="plangebiet" caption="Plangebiet" [visible]="true" alignment="left" groupCellTemplate="groupCellTemplateTOPunkt"></dxi-column>
    <dxi-column dataField="quartier" caption="Quartier" alignment="left"></dxi-column>
    <dxi-column dataField="klassifizierung" caption="Klassifizierung" [width]="130" alignment="left"></dxi-column>
    <dxi-column dataField="filtergruppe" caption="Filtergruppe" [width]="120" alignment="left"></dxi-column>
    <dxi-column dataField="pm" caption="PM" [width]="75" alignment="left"></dxi-column>
    <dxi-column dataField="pst" caption="PST" [width]="150" alignment="left"></dxi-column>
    <dxi-column dataField="antragsteller" [width]="120" caption="Antragsteller" alignment="left"></dxi-column>
    <dxi-column dataField="antragsdatum" [width]="130" caption="Antragsdatum" alignment="left" dataType="date" format="dd.MM.yyyy"></dxi-column>
    <dxi-column dataField="status" caption="Status" [width]="150" alignment="left" cellTemplate="statusCellTemplate">
      <div *dxTemplate="let data of 'statusCellTemplate'">  
        @if (data.value == 'Gestellt') {
          <span class="dx-cell-padding">{{data.value}}</span>
          <span class="material-symbols-outlined icon-round-24px backcolor-success">schedule</span>
        } 
        @else if (data.value == 'Empfohlen') {
          <span class="dx-cell-padding">{{data.value}}</span>
          <span class="material-symbols-outlined icon-round-24px backcolor-accent">info</span>
        }  
        @else if (data.value == 'Nötig') {
          <span class="dx-cell-padding">{{data.value}}</span>
          <span class="material-symbols-outlined icon-round-24px backcolor-primary">info</span>
        }
        @else if (data.value == 'Dringend') {
          <span class="dx-cell-padding">{{data.value}}</span>
          <span class="material-symbols-outlined icon-round-24px backcolor-warn">info</span>
        }  
      </div>          
    </dxi-column>
    <dxi-column type="buttons"  caption=""  [width]="80">
      <dxi-button
        hint="Aktueller Budgetantrag"
        icon="arrowright"
        [visible]="true"
        [onClick]="onBudgetantragButtonClick.bind(this)">
      </dxi-button>
    </dxi-column>
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate class="info-box">
          <i class="dx-icon-formula dx-icon-info-box"></i>
          {{dataCountText()}}
        </div>
      </dxi-item>
      @if(infoText()){
        <dxi-item location="before">
          <div *dxTemplate class="info-box">
            <i class="dx-icon-filter dx-icon-info-box"></i>
            {{infoText()}}
          </div>
        </dxi-item> 
      }
      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button
            icon="refresh"
            matTooltip="Grid zurücksetzen"
            (onClick)="gridService.resetGridState(dataGrid, appStateService.gridStateArchiv)">
          </dx-button>
        </div>
      </dxi-item>
     
      <dxi-item location="after">
        <div *dxTemplate>
           <dx-button icon="clear" matTooltip="Filter zurücksetzen" (onClick)="onHeaderFilterButtonClick()">
          </dx-button>
        </div>
      </dxi-item>
      <dxi-item location="after">
        <div *dxTemplate>
          <dx-button icon="search" matTooltip='Filterzeile ein-/ausschalten'
            (onClick)="showFilterRow.set(!this.showFilterRow())"> 
          </dx-button>
        </div>
      </dxi-item>
      <dxi-item name="columnChooserButton"></dxi-item>
      <dxi-item name="searchPanel"></dxi-item>
	  <dxi-item name="exportButton"></dxi-item>
    </dxo-toolbar>
    <dxo-group-panel [visible]="true" emptyPanelText=""></dxo-group-panel>
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
    <dxo-search-panel [visible]="true" [width]="250" placeholder="Ergebnisliste filtern" ></dxo-search-panel>
    <dxo-header-filter [visible]="showHeaderFilter()" search.enabled="true"></dxo-header-filter>                    
    <dxo-filter-row [visible]="showFilterRow()"></dxo-filter-row>
    <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
    <dxo-grouping [contextMenuEnabled]="true" [autoExpandAll]="true"></dxo-grouping>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
    <dxo-pager [visible]="true" displayMode="full" [showNavigationButtons]="true" [showPageSizeSelector]="true"></dxo-pager>
  </dx-data-grid>
</app-page-panel>
